import getEnv from '@sls-react/utils/getEnv';

export default function fireFacebookEvent(...args: any[]) {
  if (getEnv() !== 'production') {
    console.groupCollapsed('Facebook Event (fbq)');
    args.forEach(arg => console.log(arg));
    console.groupEnd();
  }

  if (window.fbq) {
    window.fbq(...args);
  }
}
